var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filteredServersList),function(server){return _c('server-card',{key:server.uuid,attrs:{"server":server,"tariff-plan":_vm.currentTariffPlan,"is-sale":_vm.isSale}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }